<script lang="ts" setup>

//vue
import {  onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/parceirosService";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import AutoCompleteCidade from "@/components/AutoCompletes/AutoCompleteCidade.vue";
import UploadFoto from "@/components/UploadFoto/Index.vue";
import DropdownCategoriasParceiros from "@/components/Dropdowns/DropdownCategoriasParceiros.vue";

  const route = useRoute();

  var controle = reactive({

    model: {
      parceiroId: 0,
      usuarioId: null,
      nome: "",
      cnpj: null,
      logradouro: null,
      numero: null,
      bairro: null,
      cidadeId: null,
      complemento: null,
      cep: null,
      telefone: null,
      celular: null,
      email: null,
      senha: null,
      observacoes: null,
      ativo: true
    } as unknown as service.Parceiro,
    foto: null as File | null,
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],

      erro: "",
      status: ""
  })

  onMounted(() => {
    
    console.log("buscar")
    
    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      service.obterPorId(Number(route.params.id))
        .then((r: any) => {
          controle.model = {
            ...r,
            cidadeId: r.cidadeId === null ? undefined : r.cidadeId
          };
        })
        .catch((error: any) => {
          controle.erro = `Erro ao carregar: ${error}`;
        });
    }

    setTimeout(() => {
      var el = document.getElementById("inputFocus");
      if (el) {
        el.focus();
      }
    }, 500);

  });

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      controle.status = "Salvando...";
      controle.erro = "";
      const resultado = await service.salvar(controle.model)

      // 4. Fazer upload das fotos se existirem
      if (controle.foto != null && controle.foto.size > 0) {

          const arquivo = controle.foto as File
          try {
            controle.status = "Salvando foto...";
            console.log(`Salvando foto...`)
            const urlImagem = await service.uploadFoto(resultado.parceiroId, arquivo)
            console.log(`Salvando foto concluído:`, urlImagem)
            
          } catch (uploadError) {
            controle.erro = `Erro ao salvar foto: ${uploadError}...`;
          }

      }

       controle.status = "Salvo com sucesso!";
       setTimeout(() => {
         controle.status = "";
       }, 3000);
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
    }
</script>

<template>
  <BreadCrumb PageTitle="Cadastro de Parceiros" 
    :items="[ 
      { label: 'Parceiros', to: '/parceiros' }, 
      { label: 'Cadastro', to: '/parceiros/cadastro' } ]" />

    <Notificacao :erro="controle.erro" 
          @limparErro="controle.erro=''" 
          :progresso="controle.status" 
          @limparProgresso="controle.status = ''" />

    <TrataTecla>
      <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-4">
          <div class="row">

            <!-- coluna 1-->
            <div class="col-md-6">
              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="empresaId" class="form-label">ID</label>
                </div>
                <div class="col-md-3">
                    <TextBox v-model="controle.model.parceiroId" id="parceiroId" :formato="'Numero'" readonly disabled />
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="nome" class="form-label obrigatorio">Nome</label>
                </div>
                <div class="col-md-9">
                    <TextBox v-model="controle.model.nome" id="inputFocus" :formato="'Maiusculo'"/>
                </div>
              </div>
              
              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="nome" class="form-label obrigatorio">Categoria</label>
                </div>
                <div class="col-md-9">
                    <DropdownCategoriasParceiros v-model="controle.model.categoriaId" id="categoriaId"/>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="cnpj" class="form-label">CNPJ</label>
                </div>
                <div class="col-md-6">
                  <TextBox v-model="controle.model.cnpj" id="cnpj"  :formato="'CpfCnpj'" class=""/>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="cep" class="form-label">CEP</label>
                </div>
                <div class=col-md-4>
                  <TextBox v-model="controle.model.cep" id="cep"  :formato="'Cep'" class=""/>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="logradouro" class="form-label">Logradouro</label>
                </div>
                <div class=col-md-9>
                  <TextBox v-model="controle.model.logradouro" id="logradouro"  :formato="'Maiusculo'" class=""/>
                </div>
              </div>
              
              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="numero" class="form-label">Número</label>
                </div>
                <div class=col-md-3>
                  <TextBox v-model="controle.model.numero" id="numero"  :formato="'Maiusculo'" class=""/>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="bairro" class="form-label">Bairro</label>
                </div>
                <div class=col-md-9>
                  <TextBox v-model="controle.model.bairro" id="bairro"  :formato="'Maiusculo'" class=""/>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="cidadeId" class="form-label">Cidade</label>
                </div>
                <div class=col-md-9>
                  <AutoCompleteCidade v-model="controle.model.cidadeId" id="cidadeId" />
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="complemento" class="form-label">Complemento</label>
                </div>
                <div class=col-md-9>
                  <TextBox v-model="controle.model.complemento" id="complemento"  :formato="'Maiusculo'" class=""/>
                </div>
              </div>


              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="telefone" class="form-label">Telefone</label>
                </div>
                <div class=col-md-6>
                  <TextBox v-model="controle.model.telefone" id="telefone"  :formato="'Telefone'" class=""/>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="celular" class="form-label">Celular</label>
                </div>
                <div class=col-md-6>
                  <TextBox v-model="controle.model.celular" id="celular"  :formato="'Telefone'" class=""/>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-3">
                  <label for="voucher" class="form-label">Voucher</label>
                </div>
                <div class=col-md-6>
                  <select v-model="controle.model.voucher" id="voucher"  class="form-select form-select-sm">
                    <option :value="null">-- Selecione --</option>
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </select>
                </div>
              </div>
              
            </div>

            <!-- coluna 2-->
            <div class="col-md-6">

              
              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="texto" class="form-label">Texto</label>
                </div>
                <div class=col-md-9>
                  <textarea v-model="controle.model.texto" id="texto"  :formato="'Texto'" rows="3" class="form-control form-control-sm"></textarea>
                </div>
              </div>

               <div class="row mb-2">
                <div class="col-md-3">
                  <label for="responsavel" class="form-label">Responsável</label>
                </div>
                <div class=col-md-9>
                  <TextBox v-model="controle.model.responsavel" id="responsavel"  :formato="'Maiusculo'" class=""/>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="valorDescontoIni" class="form-label">Desconto Min R$</label>
                </div>
                <div class=col-md-4>
                  <TextBox v-model="controle.model.valorDescontoIni" id="valorDescontoIni"  :formato="'DoisDecimais'" class="end"/>
                </div>
              </div>

               <div class="row mb-2">
                <div class="col-md-3">
                  <label for="valorDesconto" class="form-label">Desconto Max R$</label>
                </div>
                <div class=col-md-4>
                  <TextBox v-model="controle.model.valorDesconto" id="valorDesconto"  :formato="'DoisDecimais'" class="text-end"/>
                </div>
              </div>



              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="ativo" class="form-label">Ativo</label>
                </div>
                  <div class=col-md-4>
                  <select v-model="controle.model.ativo" id="ativo" class="form-select form-select-sm" >
                    <option v-for="tipo in controle.simNao" :key="String(tipo.valor)" :value="tipo.valor">{{ tipo.texto }}</option>
                  </select>
                </div>
              </div>

              
              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="foto" class="form-label">Foto</label>
                </div>
                <div class="col-md-9">
                  <UploadFoto
                    v-model="controle.foto"
                    id="foto"
                    :accept="'image/*'"
                    :alt="'Foto'"
                    :imageUrl="controle.model.arquivo ?? undefined"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class='card-footer'>
          <div class="row">
           <div class="col-md-2">
              <a class="btn btn-sm btn-primary " @click="salvar()">Gravar</a>
            </div>
            <div class="col-md-4">
              <div v-if="controle.erro == null && controle.status != null" class="fw-bold">{{ controle.status }}</div>
              <div v-if="controle.erro != null " class="fw-bold text-danger">{{ controle.erro }}</div>
            </div>
            <div class="col-md-4">
              
            </div>
             <div class="col-md-2">
              <RouterLink class="btn btn-sm btn-secondary float-end" :to="'/parceiros'">Fechar</RouterLink>
            </div>

            
          </div>
        </div>
      </div>
    </TrataTecla>

</template>